'use client'
import { __awaiter } from '../../../../_virtual/_tslib.js';
import { PublicKey, VersionedTransaction, Transaction } from '@solana/web3.js';
import { fetchCluster } from '../../../phantomRedirect/utils.js';

const isVersionedTransaction = (transaction) => !('instructions' in transaction);
const createSolanaSignerFromWalletStandard = (wallet, walletConnector) => {
    const features = wallet.features;
    const getCurrentAccount = () => __awaiter(void 0, void 0, void 0, function* () {
        const address = yield walletConnector.getAddress();
        const account = wallet.accounts.find((account) => account.address === address);
        if (!account) {
            throw new Error('Account not found');
        }
        return account;
    });
    const getChain = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const rpc = (_b = (_a = walletConnector.solNetworks[0].privateCustomerRpcUrls) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : walletConnector.solNetworks[0].rpcUrls[0];
        const cluster = yield fetchCluster(rpc);
        return `solana:${cluster}`;
    });
    const signTransaction = (transaction) => __awaiter(void 0, void 0, void 0, function* () {
        const account = yield getCurrentAccount();
        const signTransactionResult = yield features['solana:signTransaction'].signTransaction({
            account,
            chain: yield getChain(),
            transaction: transaction.serialize({
                requireAllSignatures: false,
            }),
        });
        if (isVersionedTransaction(transaction)) {
            return VersionedTransaction.deserialize(signTransactionResult[0].signedTransaction);
        }
        return Transaction.from(signTransactionResult[0].signedTransaction);
    });
    const signAllTransactions = (transactions) => __awaiter(void 0, void 0, void 0, function* () { return Promise.all(transactions.map(signTransaction)); });
    const signAndSendTransaction = (transaction) => __awaiter(void 0, void 0, void 0, function* () {
        const account = yield getCurrentAccount();
        const signedTransactions = yield features['solana:signAndSendTransaction'].signAndSendTransaction({
            account,
            chain: yield getChain(),
            transaction: transaction.serialize(),
        });
        const [{ signature }] = signedTransactions;
        return { signature: new TextDecoder().decode(signature) };
    });
    const signMessage = (message) => __awaiter(void 0, void 0, void 0, function* () {
        const account = yield getCurrentAccount();
        const messages = yield features['solana:signMessage'].signMessage({
            account,
            message,
        });
        return { signature: messages[0].signature };
    });
    return {
        addListener: () => {
            throw new Error('Not implemented');
        },
        connect: () => {
            throw new Error('Not implemented');
        },
        disconnect: () => walletConnector.endSession(),
        emit: () => {
            throw new Error('Not implemented');
        },
        eventNames: () => {
            throw new Error('Not implemented');
        },
        isBackpack: false,
        isBraveWallet: false,
        isConnected: true,
        isExodus: false,
        isGlow: false,
        isMagicEden: false,
        isPhantom: false,
        isSolflare: false,
        listenerCount: () => {
            throw new Error('Not implemented');
        },
        listeners: () => {
            throw new Error('Not implemented');
        },
        off: () => {
            throw new Error('Not implemented');
        },
        on: () => {
            throw new Error('Not implemented');
        },
        once: () => {
            throw new Error('Not implemented');
        },
        providers: [],
        get publicKey() {
            return new PublicKey(wallet.accounts[0].publicKey);
        },
        removeAllListeners: () => {
            throw new Error('Not implemented');
        },
        removeListener: () => {
            throw new Error('Not implemented');
        },
        send: () => {
            throw new Error('Not implemented');
        },
        signAllTransactions,
        signAndSendTransaction,
        signMessage,
        signTransaction,
    };
};

export { createSolanaSignerFromWalletStandard };
